function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "50.148,0 49.455,14.274 32.11,13.382 30.227,16.75 37.96,52.827 35.679,75.522 33.304,75.027  35.381,110.604 32.805,112.587 22.301,109.616 19.528,114.569 33.102,141.23 30.029,144.202 34.293,152.131 37.072,150.149  44.797,153.618 53.518,181.961 62.637,183.75 64.03,190.387 70.068,199.213 78.795,200 85.133,197.325 88.903,184.443  87.707,177.999 94.452,176.51 94.253,169.872 97.325,165.906 98.016,166.898 100.794,163.927 121.013,177.999 123.29,175.821  128.243,177.799 132.71,176.018 142.119,181.273 150.645,169.678 165.709,172.052 157.88,134.593 180.472,95.346 157.88,84.239  145.096,73.044 139.743,53.325 132.904,39.55 123.092,33.304 97.031,3.474 "
});

var Svg08 = function Svg08(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CHIH",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg08, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/08.4f04ac82.svg";
export { ForwardRef as ReactComponent };